import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ReactPlayer from "react-player";

import { Container } from "./layoutComponents";

const Nav = ({ className, source, active, fullpageApi, goToNext }) => {
  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  return (
    <div
      className={`${className} ${active ? "hidable" : " hidable hide"}`}
      id="video"
    >
      <div className="video-nav-wrap">
        <Container
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            maxWidth: "100%"
          }}
        >
          <div
            className="video-nav"
            onClick={() => {
              fullpageApi.moveSectionUp();
            }}
          >
            <img src={require(`../images/goto-prev-3x.png`)} alt="next" />
          </div>
          <div
            className="video-nav"
            onClick={() => {
              fullpageApi.moveSectionDown();
            }}
          >
            <img src={require(`../images/goto-next-3x.png`)} alt="next" />
          </div>
        </Container>
      </div>

      {source && active && !isIE11 ? (
        <ReactPlayer
          className="player"
          url={source}
          width="100vw"
          height="100%"
          playing
          onEnded={() => {
            fullpageApi.moveSectionDown();
          }}
          onReady={() => {
            console.log("ready");
          }}
          controls
        />
      ) : null}
      {isIE11 && source ? (
        <video
          id="movie"
          className="playerIE"
          width="100%"
          height="100%"
          autobuffer
          controls
          autoPlay
          preload="auto"
        >
          <source
            src={source}
            type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'
          />

          <p>OOPS! It looks like your browser doesn't support HTML5 videos.</p>
        </video>
      ) : null}
    </div>
  );
};

Nav.propTypes = {
  siteTitle: PropTypes.string
};

Nav.defaultProps = {
  siteTitle: ``
};

const StyledNav = styled(Nav)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px);
  transition: 300ms transform ease-in-out;
  z-index: 1200;

  height: calc(100vh - 176px);

  @media only screen and (min-width: 1340px) {
    height: calc(100vh - 161px);
  }

  .video-nav-wrap {
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -30px;
    width: 100vw;
    height: auto;
    z-index: 60;
  }

  .video-nav {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.8) !important;
    cursor: pointer;
    transition: 300ms opacity ease-in-out;

    &:hover {
      opacity: 0.8;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: calc(100vh - 85px);
    align-items: center;
    justify-content: center;
    display: flex;
  }

  &.active {
    transform: translate3d(0vw, 0, 0);
  }

  @media (max-width: ${p => p.theme.break}px) {
  }
`;

export default StyledNav;
